var C = Object.defineProperty, U = Object.defineProperties;
var _ = Object.getOwnPropertyDescriptors;
var p = Object.getOwnPropertySymbols;
var y = Object.prototype.hasOwnProperty, B = Object.prototype.propertyIsEnumerable;
var T = (t, e, r) => e in t ? C(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, k = (t, e) => {
  for (var r in e || (e = {}))
    y.call(e, r) && T(t, r, e[r]);
  if (p)
    for (var r of p(e))
      B.call(e, r) && T(t, r, e[r]);
  return t;
}, I = (t, e) => U(t, _(e));
var E = (t, e) => {
  var r = {};
  for (var o in t)
    y.call(t, o) && e.indexOf(o) < 0 && (r[o] = t[o]);
  if (t != null && p)
    for (var o of p(t))
      e.indexOf(o) < 0 && B.call(t, o) && (r[o] = t[o]);
  return r;
};
var m = (t, e, r) => new Promise((o, d) => {
  var l = (n) => {
    try {
      f(r.next(n));
    } catch (g) {
      d(g);
    }
  }, a = (n) => {
    try {
      f(r.throw(n));
    } catch (g) {
      d(g);
    }
  }, f = (n) => n.done ? o(n.value) : Promise.resolve(n.value).then(l, a);
  f((r = r.apply(t, e)).next());
});
const b = class u {
  constructor(e = !0) {
    this.isDebug = e;
  }
  log(...e) {
    this.isDebug && console.log(u.prefix, ...e);
  }
  time(e) {
    this.isDebug && (u.timers[e] && console.warn(`Timer '${e}' already exists and will be restarted.`), u.timers[e] = performance.now());
  }
  timeEnd(e) {
    if (!this.isDebug)
      return;
    if (!u.timers[e]) {
      console.error(`Timer '${e}' does not exist.`);
      return;
    }
    const o = performance.now() - u.timers[e];
    console.log(`${u.prefix} ${e} ${o}ms`), delete u.timers[e];
  }
  debug(...e) {
    this.isDebug && console.debug(u.prefix, ...e);
  }
  warn(...e) {
    this.isDebug && console.warn(u.prefix, ...e);
  }
};
b.prefix = "[simple-gif]";
b.timers = {};
let x = b;
function N(t) {
  const { workerUrl: e } = t;
  let r, o, d;
  const l = new Worker(e);
  l.onmessage = a;
  function a(c) {
    const { type: h, data: i } = c.data;
    switch (h) {
      case "progress": {
        r && r(i.percent, i.time, i.message);
        return;
      }
      case "complete":
        d && d(i);
        return;
      case "error":
        o && o(i);
        return;
    }
  }
  return {
    call: function() {
      let c = 0;
      return (h, i, s) => {
        l && l.postMessage({ id: c++, type: h, data: i }, { transfer: s });
      };
    }(),
    terminate: () => {
      l.terminate();
    },
    observerFunction: (c, h, i) => {
      r = c, o = h, d = i;
    }
  };
}
class W {
  constructor(e) {
    if (this._logger = new x(!!e.debug), e.workerUrl)
      this._workerUrl = e.workerUrl;
    else
      throw new Error("workerUrl is needed");
  }
  loadWorker(e, r, o) {
    this._worker = N({ workerUrl: this._workerUrl }), this._worker.observerFunction(e, r, o);
  }
  encode(e) {
    return m(this, null, function* () {
      if (e.frames.length < 0)
        throw new Error("frames is empty");
      try {
        const r = e, { progress: o, error: d, complete: l } = r, a = E(r, ["progress", "error", "complete"]);
        this.loadWorker(o, d, l);
        const f = I(k({}, a), { debug: this._logger.isDebug }), g = typeof e.frames[0].data == "string" ? void 0 : e.frames.map((c) => c.data);
        if (!this._worker)
          throw new Error("worker is not loaded");
        this._worker.call("encode", f, g);
      } catch (o) {
        e.error && e.error(o);
      }
    });
  }
  decodeFrames(e) {
    return m(this, null, function* () {
      try {
        const { progress: r, error: o, complete: d, source: l } = e;
        this.loadWorker(r, o, d);
        const a = { source: l, debug: this._logger.isDebug };
        if (!this._worker)
          throw new Error("worker is not loaded");
        this._worker.call("decodeFrames", a);
      } catch (r) {
        e.error && e.error(r);
      }
    });
  }
  stopWorker() {
    var e;
    (e = this._worker) == null || e.terminate(), this._logger.log("wrker terminated");
  }
}
const A = "GIF", O = ["87a", "89a"], v = 44, D = 33, L = 255, R = 11, $ = 254, F = 249, P = 4, X = 1, z = 1, M = 59;
function j(t, e, r) {
  let o;
  if (ArrayBuffer.isView(t))
    o = t.buffer;
  else if (t instanceof ArrayBuffer)
    o = t;
  else {
    const { width: d, height: l } = r || {}, a = new OffscreenCanvas(d, l), f = a.getContext("2d");
    if (!f)
      throw new Error("Failed to create canvas context2d");
    a.width = d != null ? d : typeof t.width == "number" ? t.width : t.width.baseVal.value, a.height = l != null ? l : typeof t.height == "number" ? t.height : t.height.baseVal.value, f.drawImage(t, 0, 0, a.width, a.height), o = f.getImageData(0, 0, a.width, a.height).data.buffer;
  }
  switch (e) {
    case "uint8Array":
      return new Uint8Array(o);
    case "uint8ClampedArray":
      return new Uint8ClampedArray(o);
    case "dataView":
      return new DataView(o);
    default:
      throw new Error("Unsupported output format");
  }
}
class G {
  constructor(e) {
    this.offset = 0, this._view = j(e, "dataView");
  }
  readByte() {
    return this._view.getUint8(this.offset++);
  }
  readBytes(e) {
    return Array.from({ length: e }).map(() => this.readByte());
  }
  readString(e) {
    return String.fromCharCode(...this.readBytes(e));
  }
  readUnsigned() {
    return [this._view.getUint16(this.offset, !0), this.offset += 2][0];
  }
  readBits() {
    return this._view.getUint8(this.offset++).toString(2).padStart(8, "0").split("").map(Number);
  }
  readColorTable(e) {
    return Array.from({ length: e }, () => Array.from(this.readBytes(3)));
  }
  readSubBlock() {
    const e = [];
    for (; ; ) {
      const r = this.readByte();
      if (r === 0 && this._view.getUint8(this.offset) !== 0)
        break;
      e.push(r);
    }
    return e;
  }
}
function H(t) {
  const e = {}, r = new G(t), o = () => ({ index: 0, delay: 100, disposal: 0 }), d = r.readString(3), l = r.readString(3);
  if (d !== A || !O.includes(l))
    throw new Error("This is not a 87a/89a GIF data.");
  e.version = l, e.width = r.readUnsigned(), e.height = r.readUnsigned();
  const a = r.readBits();
  e.globalColorTable = !!a[0], e.colorResoluTion = parseInt(a.slice(1, 4).join(""), 2) + 1, e.colorTableSorted = !!a[4];
  const f = parseInt(a.slice(5, 8).join(""), 2);
  e.colorTableSize = Math.pow(2, f + 1), e.backgroundColorIndex = r.readByte(), e.pixelAspectRatio = r.readByte(), e.globalColorTable && (e.colorTableSize ? e.colorTable = r.readColorTable(e.colorTableSize) : r.readSubBlock()), e.frames = [];
  let n = o();
  const g = [], c = [];
  for (; ; ) {
    const h = r.readByte();
    if (g.push(h), h === v) {
      n.left = r.readUnsigned(), n.top = r.readUnsigned(), n.width = r.readUnsigned(), n.height = r.readUnsigned();
      const i = r.readBits();
      n.localColorTable = !!i[0], n.interlaced = !!i[1], n.colorTableSorted = !!i[2], n.reserved = parseInt(i.slice(3, 5).join(""), 2);
      const s = parseInt(i.slice(5, 8).join(""), 2);
      for (n.colorTableSize = Math.pow(2, s + 1), n.localColorTable && (n.colorTable = r.readColorTable(n.colorTableSize)), n.lzwMinCodeSize = r.readByte(), n.dataPositions = []; ; ) {
        const w = r.readByte();
        if (w === 0)
          break;
        const S = r.offset;
        n.dataPositions.push([S, w]), r.offset = S + w;
      }
      e.frames.push(n), n = o(), n.index = e.frames.length;
      continue;
    }
    if (h === D) {
      const i = r.readByte();
      if (c.push(i), i === L) {
        if (r.readByte() !== R)
          continue;
        const s = {
          identifier: r.readString(8),
          code: r.readString(3),
          data: []
        };
        `${s.identifier}${s.code}` == "NETSCAPE2.0" && r.readByte() === 3 && (e.looped = !!r.readByte(), e.loopCount = r.readUnsigned()), s.data = r.readSubBlock(), n.application = s;
        continue;
      }
      if (i === $) {
        n.comment = r.readSubBlock().map((s) => String.fromCharCode(s)).join("");
        continue;
      }
      if (i === F) {
        if (r.readByte() !== P)
          continue;
        const s = r.readBits(), w = {
          // ↓ <Packed Fields>
          reserved: parseInt(s.slice(0, 3).join(""), 2),
          disposal: parseInt(s.slice(3, 6).join(""), 2),
          userInput: !!s[6],
          transparent: !!s[7],
          // ↑ <Packed Fields>
          delayTime: r.readUnsigned(),
          transparentIndex: r.readByte()
        };
        r.readSubBlock(), n.graphicControl = w, n.disposal = w.disposal, n.delay = (w.delayTime || 10) * 10;
        continue;
      }
      if (i === X) {
        if (r.readByte() !== z)
          continue;
        n.plainText = {
          left: r.readUnsigned(),
          top: r.readUnsigned(),
          width: r.readUnsigned(),
          height: r.readUnsigned(),
          cellWidth: r.readByte(),
          cellHeight: r.readByte(),
          colorIndex: r.readByte(),
          backgroundColorIndex: r.readByte(),
          data: r.readSubBlock()
        };
        continue;
      }
      console.warn(
        `Unknown extension block: 0x${i.toString(16)}`,
        g.slice(0, g.length - 1).map((s) => `0x${s.toString(16)}`),
        c.slice(0, c.length - 1).map((s) => `0x${s.toString(16)}`)
      );
      continue;
    }
    if (h === M)
      break;
    console.warn(
      `Unknown block: 0x${h.toString(16)}`,
      g.slice(0, g.length - 1).map((i) => `0x${i.toString(16)}`),
      c.slice(0, c.length - 1).map((i) => `0x${i.toString(16)}`)
    );
  }
  return e;
}
export {
  W as SimpleGif,
  H as decode
};
